import React from "react";
// import "./HeaderInner.css";
import AshleyLogo1 from '../images/ashley-logo1.png';
function Header() {
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="logo">
          <img
            src={AshleyLogo1}
            alt="ashley-logo1.png"
            className="img-responsive"
          />
        </div>
      </div>
    </div>
  );
}
export default Header;
